import { useMemo } from 'react';

import { type Asset } from '@/services/db/asset/entity';

import { type FilterOptions, type FilterResult, type UnselectableReasons } from '../types';
import { isPdf } from '../utils/is-pdf';

export function useAssetFilters(assets: Asset[], options: FilterOptions): FilterResult {
  const { parentFolderId, isSearchMode, filterFileSizeInBytes, isFilteringByBytesEnabled, filterPdfs } = options;

  return useMemo(() => {
    const reasons: UnselectableReasons = {};
    const filtered: Asset[] = [];

    for (const asset of assets) {
      if (asset.id === parentFolderId) continue;

      let isVisible = false;

      if (isSearchMode) {
        isVisible = true;
      } else {
        const isInCurrentFolder =
          (parentFolderId === null && asset.parent_id == null) || asset.parent_id === parentFolderId;
        isVisible = isInCurrentFolder;
      }

      if (!isVisible) continue;

      if (filterPdfs === true && !asset.is_dir && isPdf(asset)) {
        reasons[asset.id] = 'PDFs cannot be selected as images.';
      }

      if (
        filterFileSizeInBytes != null &&
        isFilteringByBytesEnabled &&
        !asset.is_dir &&
        asset.size > filterFileSizeInBytes
      ) {
        reasons[asset.id] = 'Image is larger than acceptable size limit.';
      }

      filtered.push(asset);
    }

    return { filteredAssets: filtered, unselectableReasons: reasons };
  }, [assets, parentFolderId, isSearchMode, filterFileSizeInBytes, isFilteringByBytesEnabled, filterPdfs]);
}
